import { render, staticRenderFns } from "./HomeAthleteReviews.vue?vue&type=template&id=0f967792&scoped=true&"
import script from "./HomeAthleteReviews.vue?vue&type=script&lang=js&"
export * from "./HomeAthleteReviews.vue?vue&type=script&lang=js&"
import style0 from "./HomeAthleteReviews.vue?vue&type=style&index=0&id=0f967792&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f967792",
  null
  
)

export default component.exports